import { parseItemDetails } from './formatters';
import { GHOST_KEYS } from './ghostKeys';

const slug = (s: string): string => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

const ghostUrl = (key: string): string => `/ghosts/${key}.webp`;

export const getGhostSrc = (name: string): string => {
  const { weaponName, condition } = parseItemDetails(name);
  const key = slug(weaponName);
  if (GHOST_KEYS.has(key)) return ghostUrl(key);
  if (key === 'package' || key === 'collection') return ghostUrl('case');
  if (!condition && name.includes(' | ')) return ghostUrl('agent');
  return ghostUrl('default');
};
